export * from './bgAgreement'
export * from './bgCommon'
export * from './bgRequests'
export * from './bgStatus'
export * from './error'
export * from './bgDocument'
export * from './segment'
export * from './productType'
export * from './BgFlagpowerattornay'
export * from './bgModal'

export const AUTHPOSITION_ITEMS = ['Генеральный директор', 'Директор']
